<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Upload Product Kit Mapping</p>
          </div>
        </div>
        <v-btn
          :to="{ name: 'listKitMapping' }"
          v-if="$vuetify.breakpoint.smAndUp"
          elevation="1"
          absolute
          right
          top
        >
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
      </div>
    </section>
    <form
      @submit.prevent="onSubmit"
      enctype="multipart/form-data"
      name="SaveWowKitMapping"
    >
      <card-component>
        <v-row>
          <v-col cols="12" md="4" lg="3" sm="4" xs="6">
            <v-autocomplete
              name="kittype"
              v-model="kit"
              :items="constantKit"
              required
              key="id"
              @change="setkitType()"
              return-object
              item-text="name"
            >
              <template v-slot:label>
                Kit Type <span class="error--text">*</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="3" sm="4" xs="6">
            <v-autocomplete
              name="year"
              v-model="academicYear1"
              required
              item-value="id"
              :items="academicYears"
              key="id"
              item-text="academicYear"
            >
              <template v-slot:label>
                Year <span class="error--text">*</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="3" sm="4" xs="6">
            <v-autocomplete
              name="classId"
              v-model="classID"
              :items="classes"
              required
              key="id"
              item-text="name"
              item-value="id"
            >
              <template v-slot:label>
                Class <span class="error--text">*</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="3" sm="4" xs="6" v-if="isSampleKitSelected">
            <v-autocomplete
              name="category"
              v-model="category"
              :items="categoryOptions"
              required
              item-text="value"
              item-value="value"
            >
              <template v-slot:label>
                Category <span class="error--text">*</span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" lg="4" sm="4" xs="6">
            <div class="content">
              <b> .csv file must contain<br /></b>
              <ul>
                <li>
                  FCID: Creator needs to provide FCID and it must be numeric.
                </li>
                <li>
                  Quantity: quantity of FCID needs to be provided and it must be
                  numeric.
                </li>
                <li>
                  Mandatory / Optional: In 3rd column, whether that FCID
                  ismandatory or optional in ordering will be provided.
                </li>
                <li>
                  Alternate FCID 1 (Optional): If not blank must be contain
                  numeric value.
                </li>
                <li>
                  Alternate FCID 2 (Optional): If not blank must be contain
                  numeric value.
                </li>
              </ul>
            </div>
          </v-col>
          <v-col cols="12" md="4" lg="4" sm="4" xs="6">
            <b-field>
              <b-upload
                v-model="dropFiles"
                @input="csvToJsonInput(dropFiles)"
                accept=".csv"
                single
                drag-drop
                title="Please do upload .csv file only"
              >
                <section class="section">
                  <div class="content has-text-centered">
                    <p>
                      <b-icon icon="upload" size="is-large"> </b-icon>
                    </p>
                    <p>Drop your files here or click to upload</p>
                  </div>
                </section>
              </b-upload>
            </b-field>
            <div v-show="flag">
              <v-chip
                class="mt-1"
                color="indigo"
                text-color="white"
                @click:close="deleteDropFile"
                close
                label
              >
                {{
                  dropFiles !== null && dropFiles.name !== 'undefined'
                    ? dropFiles.name
                    : ''
                }}
              </v-chip>
            </div>
          </v-col>
          <v-col cols="12" md="4" lg="4" sm="4" xs="6">
            <div class="column has-text-centered">
              <a
                class="button is-link"
                href="https://intellitots.s3.ap-south-1.amazonaws.com/KitConfiguration.csv"
                download
                >Download dummy file</a
              >
            </div>
          </v-col>
          <v-col cols="12" md="12" xs="12" lg="12" sm="12">
            <footer class="column has-text-centered">
              <button class="button is-success" type="submit">Upload</button>
            </footer>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" lg="12" sm="12" xs="12">
            <div class="columns is-mobile">
              <div
                class="column"
                v-if="resCountFlag"
                style="display: inline-block; margin-right: 5%"
              >
                <b-button class="has-text-left" outlined type="is-success"
                  >Success: {{ resCount.success }} </b-button
                >&nbsp;
                <b-button
                  class="button has-text-centered"
                  outlined
                  type="is-info"
                  >Already Exist: {{ resCount.alreadyExist }}</b-button
                >&nbsp;
                <b-button
                  class="button has-text-right"
                  outlined
                  type="is-danger"
                  >Failure: {{ resCount.failure }}</b-button
                >
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="12" lg="12" xs="12" sm="12">
            <v-data-table
              v-if="jsonData.length > 0"
              disable-pagination
              :hide-default-footer="true"
              :headers="jsonHeader"
              :items="jsonData"
            >
              <template v-slot:item.status="{ item }">
                <span
                  :class="
                    item.statusCode === 200
                      ? 'has-text-success'
                      : 'has-text-danger'
                  "
                  >{{ item.status }}
                </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </card-component>
    </form>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import csvtojsonV2 from 'csvtojson'
import _ from 'lodash'

export default {
  name: 'uploadKitMapping',
  components: {
    CardComponent
  },
  props: ['kitType', 'setKitMapId'],

  data () {
    return {
      flag: '',
      jsonData: [],
      jsonHeader: [
        { text: 'Product ID', value: 'FCID' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'isMandatory', value: 'isMandatory' },
        { text: 'Alternate FCID 1', value: 'alternateFCID1' },
        { text: 'Alternate FCID 2', value: 'alternateFCID2' },
        { text: 'Status', value: 'status' }
      ],
      kitTypeVar: '',
      dropFiles: [],
      WowkitTypes: [],
      classID: '',
      classes: [],
      total: 0,
      paginated: false,
      kit: {},
      perPage: 10,
      loadingComponent: null,
      constantKit: _.filter(
        constants.KIT,
        (obj) => obj.isDisplayOnMapping === true
      ),
      fileinput: '',
      isResponse: false,
      academicYears: [],
      academicYear1: null,
      csvErrorFlag: false,
      resCountFlag: false,
      resCount: {},
      category: null
    }
  },
  created: function () {
    this.onStart()
    this.getAcademicYears()
  },
  watch: {
    kitType: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onStart()
      }
    }
  },
  computed: {
    categoryOptions () {
      return constants.SAMPLE_KIT_PRODUCT_CATEGORIES
    },
    isSampleKitSelected () {
      return this.kit && (this.kit.name === 'SAMPLE KIT' || this.kit.id === 'SAMPLE_KIT')
    }
  },
  methods: {
    onStart: async function () {
      this.kit = _.find(this.constantKit, (item) =>
        _.isEqual(item.route, this.kitType)
      )
      if (_.isEmpty(this.kit)) {
        this.$router.push({
          name: 'listKitMapping',
          params: { kitType: this.constantKit[0].route }
        })
      }
      this.classes = []
      await this.getClassList()
    },
    setkitType: function () {
      // console.log(this.kit)
      if (!this.isSampleKitSelected) {
        this.category = null
      }
      if (!_.isEmpty(this.kit)) {
        this.$router.push({
          name: 'uploadKitMapping',
          params: { kitType: this.kit.route }
        })
      }
    },
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        this.academicYears = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    dateFormat: function (i) {
      let j = i % 10
      let k = i % 100
      if (j === 1 && k !== 11) {
        return i + 'st'
      }
      if (j === 2 && k !== 12) {
        return i + 'nd'
      }
      if (j === 3 && k !== 13) {
        return i + 'rd'
      }
      return i + 'th'
    },
    getKitName: function (kitType) {
      return this.kit.name
    },
    readerFile: function (file, onLoadCallback) {
      let reader = new FileReader()
      reader.onload = onLoadCallback
      reader.readAsText(file)
    },
    csvToJsonInput: function (files) {
      if (files === null) {
        return this.$dialog.error({
          title: 'Error while choosing the file',
          text: 'Incorrect file format. Please upload .csv file'
        })
      } else {
        // let kitName = []
        this.loadingComponent = this.$buefy.loading.open()
        this.isResponse = false
        let self = this
        this.resCountFlag = false
        this.resCount = {}
        this.csvErrorFlag = false

        if (files.length > 1) {
          this.dropFiles.splice(0, 1)
        }
        let file = files

        this.readerFile(file, async (e) => {
          try {
            let numberPattern = /^\d+\.?\d*$/
            self.jsonData = await csvtojsonV2().fromString(e.target.result)
            /* Resolve Empty Value, Check string contains only numeric value or not and convert it to number */
            _.forEach(self.jsonData, (item) => {
              if (item.FCID !== '' && !_.isEmpty(item.FCID)) {
                item.FCID = Number(
                  numberPattern.test(item.FCID) ? item.FCID : 0
                )
              } else {
                item.FCID = 0
              }
              if (item.quantity !== '' && !_.isEmpty(item.quantity)) {
                item.quantity = Number(
                  numberPattern.test(item.quantity) ? item.quantity : 0
                )
              } else {
                item.quantity = 0
              }
              if (
                item.alternateFCID1 !== '' &&
                !_.isEmpty(item.alternateFCID1)
              ) {
                item.alternateFCID1 = Number(
                  numberPattern.test(item.alternateFCID1)
                    ? item.alternateFCID1
                    : 0
                )
              } else {
                item.alternateFCID1 = 0
              }
              if (
                item.alternateFCID2 !== '' &&
                !_.isEmpty(item.alternateFCID2)
              ) {
                item.alternateFCID2 = Number(
                  numberPattern.test(item.alternateFCID2)
                    ? item.alternateFCID2
                    : 0
                )
              } else {
                item.alternateFCID2 = 0
              }
              item.isMandatory =
                item.isMandatory !== '' ? item.isMandatory : 'No'
            })

            /* Add Validation for FCID,Quantity,alternateFCID1,alternateFCID2 */
            _.forEach(self.jsonData, (item) => {
              let errorMsg = ''

              if (typeof item.FCID === 'undefined' || item.FCID === 0) {
                errorMsg += 'ProductId' + ', '
              }
              if (typeof item.quantity === 'undefined' || item.quantity < 0) {
                errorMsg += 'Quantity' + ', '
              }
              if (
                typeof item.alternateFCID1 !== 'undefined' &&
                typeof item.alternateFCID2 !== 'undefined'
              ) {
                if (
                  item.alternateFCID1 !== 0 &&
                  (item.alternateFCID1 === item.FCID ||
                    item.alternateFCID1 === item.alternateFCID2)
                ) {
                  errorMsg += 'Alternate FCID 1' + ', '
                }
              }
              if (
                typeof item.alternateFCID1 !== 'undefined' &&
                typeof item.alternateFCID2 !== 'undefined'
              ) {
                if (
                  item.alternateFCID2 !== 0 &&
                  (item.alternateFCID2 === item.FCID ||
                    item.alternateFCID2 === item.alternateFCID1)
                ) {
                  errorMsg += 'Alternate FCID 2' + ', '
                }
              }
              if (!this.csvErrorFlag) {
                this.csvErrorFlag = errorMsg !== ''
              }
              item.status = errorMsg !== '' ? errorMsg.slice(0, -2) : ''
              item.statusCode = errorMsg !== '' ? 99 : 200
            })
          } catch (e) {
            self.jsonData = 'this is not running'
          }
        })
        this.flag = true
        this.loadingComponent.close()
      }
    },
    deleteDropFile (index) {
      this.isResponse = false
      delete this.dropFiles.name
      this.jsonData = []
      this.dropFiles = []
      this.flag = false
      this.resCountFlag = false
      this.resCount = {}
      return this.dropFiles
    },

    getClassList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const studentclasses = await http.get(
          `${constants.API_URL}/api/students/class`
        )
        this.classes = studentclasses.data.rows

        this.classes.filter((item) => {
          item.category = item.category ? ' ( ' + item.category + ' )' : ''
          item.name = item.name + ' ' + item.category
        })
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },

    async onSubmit (event) {
      if (this.csvErrorFlag) {
        return this.$dialog.error({
          title: 'Error in CSV data',
          text: 'Incorrect CSV data. Please check before upload.'
        })
      }
      this.$dialog.confirm({
        text: 'Do you really want to save?',
        title: 'Confirm',
        actions: {
          false: {
            text: 'Cancel',
            handle: () => {
              this.dropFiles = []
            }
          },
          true: {
            color: 'success',
            text: 'Ok',
            handle: async () => {
              this.hasClicked = true
              this.loader = true
              this.loadingComponent = this.$buefy.loading.open()
              /* Add Record */
              try {
                let payload = {}
                payload.kitName = this.kit.id
                payload.class = this.classID
                payload.academicYear = this.academicYear1
                payload.kitProductList = []
                /* Looping CSV Data for payload */
                _.forEach(this.jsonData, (item) => {
                  // Add productCategory only for SAMPLE KIT
                  let obj = {
                    FCID: item.FCID,
                    quantity: item.quantity,
                    alternateFCID1: item.alternateFCID1,
                    alternateFCID2: item.alternateFCID2,
                    isMandatory: item.isMandatory
                  }
                  if (this.isSampleKitSelected && this.category) {
                    obj.productCategory = this.category // value, e.g. "STUDENT_KIT"
                  }
                  payload.kitProductList.push(obj)
                })
                await http
                  .post(
                    `${constants.API_URL}/api/kitSetMapping/bulk-create`,
                    payload
                  )
                  .then((res) => {
                    if (res.status === 200) {
                      if (res.data.response.length > 0) {
                        this.jsonData = res.data.response
                        if (Object.keys(res.data.count).length > 0) {
                          this.resCountFlag = true
                          this.resCount = res.data.count
                        }
                      }
                    }
                  })
                this.loadingComponent.close()
                this.loader = false
              } catch (e) {
                this.loadingComponent.close()
                const errorTitle =
                  (e && e.response && e.response.data.error) || e.error
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                return this.$dialog.error({
                  title: errorTitle,
                  text: errorMessage
                })
              }
            }
          }
        }
      })
    }
  }
}
</script>
<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
td {
  border: 1px dashed black;
  padding: 5px;
}
th {
  background: orange;
}
</style>
